import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-trim-example',
  setup(__props) {

const trimEdgeList = [
  { label: 'basePlankManager.frontTrim', value: 'top' },
  { label: 'basePlankManager.backTrim', value: 'bottom' },
  { label: 'basePlankManager.leftTrim', value: 'left' },
  { label: 'basePlankManager.rightTrim', value: 'right' },
]
function translateLang(key: string) {
  return translate(key)
}

return { __sfc: true,trimEdgeList, translateLang }
}

})